var _path, _ellipse;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupplierLogoDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 37,
    viewBox: "0 0 41 37",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.9321 25.393V26.8714V32.4807C39.9321 34.6899 38.1412 36.4807 35.9321 36.4807H10.0354M39.9321 25.393V5C39.9321 2.79086 38.1412 1 35.9321 1H5.06641C2.85727 1 1.06641 2.79086 1.06641 5V32.4807C1.06641 34.6899 2.85727 36.4807 5.06641 36.4807H10.0354M39.9321 25.393C34.9493 18.6172 21.9941 11.0529 10.0354 36.4807",
    stroke: "#383434",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.0249,
    cy: 12.8198,
    rx: 5.23191,
    ry: 5.17427,
    stroke: "#383434",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupplierLogoDefault);
export default __webpack_public_path__ + "static/media/supplierLogoDefault.2a8f8f12634aa0dff993f02dc28fe741.svg";
export { ForwardRef as ReactComponent };